<template>
    <v-menu min-width="200">
        <template v-slot:activator="{ on }">
            <v-icon v-on="on" v-if="!activator">keyboard_arrow_down</v-icon>
            <v-btn v-on="on" fab small v-else>
                <v-avatar size="40px">
                    <img :src="activator">
                </v-avatar>
            </v-btn>
        </template>
        <slot name="dropdown"></slot>
    </v-menu>
</template>

<script>
    export default {
        props: ['activator'],
        data() {
            return {
            }
        }
    }
</script>